<template>
  <b-form id="privilege-information" @submit.prevent="onSubmitForm">
    <information
      :form-data="formData"
      :is-edit="isEdit"
      :optionData="optionData"
      @onSelectPrivilegeType="onSelectPrivilegeType"
      @onSelectInventory="onSelectInventory"
    />
    <mobile-topup
      ref="mobileTopup"
      v-if="formData.privilegeType == PRIVILEGE_TYPE.TOPUP"
      :is-edit="isEdit"
    />
    <exchange
      v-if="formData.privilegeType == PRIVILEGE_TYPE.EXCHANGE"
      :is-edit="isEdit"
      :form-data="formData"
      @onSelectCarrierExchange="onSelectCarrierExchange"
      @onSetSpinValueExchange="onSetSpinValueExchange"
    />
    <redemptions 
      :form-data="formData" @onNumberInput="onNumberInput" 
       @onUpdatePointRef="onUpdatePointRef"
       @onUpdateValueRef="onUpdateValueRef"
    />
    <redeem-limit
      v-if="formData.RedeemLimit == 1 && formData.privilegeType != PRIVILEGE_TYPE.TOPUP"
      :form-data="formData"
      @onNumberInput="onNumberInput"
    />
    <issue-limit
      v-if="formData.RedeemLimit == 1"
      :form-data="formData"
      @onNumberInput="onNumberInput"
    />
    <coupon-code
      v-if="formData.privilegeType == PRIVILEGE_TYPE.CPC"
      :form-data="formData"
      :is-edit="isEdit"
      @onNumberInput="onNumberInput"
    />
    <expiration-mode
      v-if="
        formData.privilegeType == PRIVILEGE_TYPE.TOPUP
      "
      :form-data="formData"
      @onNumberInput="onNumberInput"
    />

    <assign-inventory-modal
      v-if="modalType.assignInventory"
      :privilege-obj="privilegeSelect"
      @onCloseModal="closeAssignModal"
      @onSelectAssignInventory="onSelectAssignInventory"
    />
    <div class="privilege-btn-wrp mt-2 mb-2">
      <div class="d-flex justify-content-center">
        <cancel-button class="mr-1" @click.native="onBack" />
        <save-button
          :type="'submit'"
          class="ml-1"
          :btn-label="'Next'"
          :loading="loading.btnSave"
        />
      </div>
    </div>
  </b-form>
</template>

<script>
import { onBeforeMount } from "@vue/composition-api";
import usePrivilegeInformation from "../hooks/usePrivilegeInformation";
import ExpirationMode from "./privilege-information/ExpirationMode.vue";
import IssueLimit from "./privilege-information/IssueLimit.vue";
import RedeemLimit from "./privilege-information/RedeemLimit.vue";
import Redemptions from "./privilege-information/Redemptions.vue";
import AssignInventoryModal from "../../privilege-list/components/AssignInventoryModal.vue";
import CouponCode from "./privilege-information/CouponCode.vue";
import Information from "./privilege-information/Information.vue";
import MobileTopup from "./privilege-information/MobileTopup.vue";
import Exchange from "./privilege-information/Exchange.vue";

export default {
  components: {
    ExpirationMode,
    IssueLimit,
    RedeemLimit,
    Redemptions,
    AssignInventoryModal,
    CouponCode,
    Information,
    MobileTopup,
    Exchange,
  },
  props: {
    isEdit: { type: Boolean, default: false },
    privilegeId: { type: Number, default: 0 },
  },
  setup(props) {
    const {
      PRIVILEGE_TYPE,
      formData,
      optionData,
      modalType,
      loading,
      privilegeSelect,
      openAssignModal,
      closeAssignModal,
      onSubmitForm,
      onSelectStore,
      onSelectInventory,
      onNumberInput,
      onBack,
      onSelectAssignInventory,
      onSelectPrivilegeType,
      fetchInfoDetail,
      checkFormCreateOrEdit,
      onSelectCarrierExchange,
      onSetSpinValueExchange,
      onUpdatePointRef,
    onUpdateValueRef,
    } = usePrivilegeInformation(props);

    onBeforeMount(() => {
      checkFormCreateOrEdit();
      if (props.privilegeId || props.isEdit) {
        formData.privilegeId = props.privilegeId;
        fetchInfoDetail();
      }
    });

    return {
      PRIVILEGE_TYPE,
      formData,
      optionData,
      modalType,
      loading,
      privilegeSelect,
      onSelectStore,
      onSelectInventory,
      openAssignModal,
      closeAssignModal,
      onSubmitForm,
      onNumberInput,
      onBack,
      onSelectAssignInventory,
      onSelectPrivilegeType,
      fetchInfoDetail,
      checkFormCreateOrEdit,
      onSelectCarrierExchange,
      onSetSpinValueExchange,
      onUpdatePointRef,
    onUpdateValueRef,
    };
  },
};
</script>
